import React, { useState, useEffect } from "react";
import { db } from "../firebase";
import { doc, getDoc, setDoc } from "firebase/firestore";

const S = {
  card:{background:"#fff",border:"0.5px solid #e0dfd8",borderRadius:12,padding:"16px 20px",marginBottom:16},
  btn:{fontSize:12,padding:"5px 13px",borderRadius:8,border:"0.5px solid #ccc",background:"#fff",cursor:"pointer",fontFamily:"sans-serif"},
  btnPrimary:{fontSize:12,padding:"5px 13px",borderRadius:8,border:"none",background:"#C0111F",color:"#fff",cursor:"pointer",fontFamily:"sans-serif"},
  input:{width:"100%",padding:"6px 9px",fontSize:12,border:"0.5px solid #ccc",borderRadius:8,fontFamily:"sans-serif",background:"#fff",boxSizing:"border-box"},
  label:{fontSize:11,color:"#888",marginBottom:3},
};

const DEFAULTS = {
  firmName: "Ficsori Accounting",
  ownerName: "Frank Ficsori",
  email: "frank@ficsoriaccounting.com",
  phone: "(941) 780-4662",
  website: "www.ficsoriaccounting.com",
  slogan: "Knowing your numbers is knowing your power.",
};

export default function Settings({ user, onLogout }) {
  const [form, setForm] = useState(DEFAULTS);
  const [saved, setSaved] = useState(false);
  const [saving, setSaving] = useState(false);
  const [twoFA, setTwoFA] = useState(true);
  const [auditLog, setAuditLog] = useState(true);

  useEffect(()=>{
    getDoc(doc(db,"settings","firm")).then(snap=>{
      if(snap.exists()) setForm({...DEFAULTS,...snap.data()});
    }).catch(()=>{});
  },[]);

  const set = (k,v) => setForm(f=>({...f,[k]:v}));

  const save = async () => {
    setSaving(true);
    try{
      await setDoc(doc(db,"settings","firm"), form, {merge:true});
      setSaved(true);
      setTimeout(()=>setSaved(false), 3000);
    }catch(e){ alert("Failed to save: "+e.message); }
    setSaving(false);
  };

  return (
    <div>
      <div style={{fontSize:14,fontWeight:500,marginBottom:14}}>Settings</div>
      <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:16}}>
        <div>
          <div style={S.card}>
            <div style={{fontSize:13,fontWeight:500,marginBottom:12}}>Firm Profile</div>
            {[
              ["Firm name","firmName"],
              ["Your name","ownerName"],
              ["Email","email"],
              ["Phone","phone"],
              ["Website","website"],
              ["Slogan","slogan"],
            ].map(([label,key])=>(
              <div key={key} style={{marginBottom:10}}>
                <div style={S.label}>{label}</div>
                <input style={S.input} value={form[key]||""} onChange={e=>set(key,e.target.value)}/>
              </div>
            ))}
            {saved&&<div style={{fontSize:12,color:"#3B6D11",background:"#EAF3DE",padding:"6px 10px",borderRadius:8,marginBottom:8}}>✓ Changes saved successfully</div>}
            <button style={{...S.btnPrimary,marginTop:4}} onClick={save} disabled={saving}>
              {saving?"Saving...":"Save Changes"}
            </button>
          </div>
        </div>
        <div>
          <div style={S.card}>
            <div style={{fontSize:13,fontWeight:500,marginBottom:12}}>Security</div>
            {[
              ["Mandatory 2FA for clients", twoFA, ()=>setTwoFA(v=>!v)],
              ["Audit log all file access", auditLog, ()=>setAuditLog(v=>!v)],
            ].map(([label,on,toggle])=>(
              <div key={label} style={{display:"flex",justifyContent:"space-between",alignItems:"center",padding:"8px 0",borderBottom:"0.5px solid #f0efe8",fontSize:13}}>
                <span>{label}</span>
                <div onClick={toggle} style={{width:36,height:20,background:on?"#C0111F":"#ccc",borderRadius:10,position:"relative",cursor:"pointer"}}>
                  <div style={{position:"absolute",top:2,[on?"right":"left"]:2,width:16,height:16,borderRadius:"50%",background:"#fff"}}/>
                </div>
              </div>
            ))}
          </div>
          <div style={S.card}>
            <div style={{fontSize:13,fontWeight:500,marginBottom:12}}>Your Certifications</div>
            <div style={{display:"flex",flexDirection:"column",gap:8}}>
              <span style={{fontSize:11,padding:"5px 10px",borderRadius:4,background:"#E6F1FB",color:"#0C447C",border:"0.5px solid #85B7EB"}}>QuickBooks ProAdvisor — Level 1</span>
              <span style={{fontSize:11,padding:"5px 10px",borderRadius:4,background:"#E1F5EE",color:"#0F6E56",border:"0.5px solid #7ECBB5"}}>Certified Public Accountant (CPA)</span>
            </div>
          </div>
          <div style={S.card}>
            <div style={{fontSize:13,fontWeight:500,marginBottom:12}}>Account</div>
            <div style={{fontSize:12,color:"#888",marginBottom:10}}>Signed in as: {user?.email}</div>
            <button style={{...S.btn,color:"#A32D2D",borderColor:"#FCEBEB"}} onClick={onLogout}>Sign Out</button>
          </div>
        </div>
      </div>
    </div>
  );
}
